// ────────────────────────────────────────
// Yahoo Finance 스트리머 — 주식(미국·한국) 틱 단위 실시간 (2026-06-13 실측 검증)
// - wss://streamer.finance.yahoo.com/?version=2 : Yahoo 웹사이트 자체가 쓰는 푸시 채널
//   (v2 = JSON {message: <base64 protobuf>} 래퍼 · 구독 = {"subscribe":[심볼...]})
// - 실측: AAPL 장후에도 틱 4~10초 간격 수신 · BTC 초단위 · 한국(.KS)은 장중 검증 대기
// - 비공식(현행 Yahoo quote/ohlcv와 동일 회색지대) — 끊기면 기존 3s/10s 폴링이 폴백
// ────────────────────────────────────────
// protobuf 디코딩은 @core/sim/market/yahooPricingDecode에 둔다.
import { decodePricing, type YahooTick } from '@core/sim/market/yahooPricingDecode';

/**
 * 주식 틱 구독 — onTick으로 가격(+가능 시 일누적거래량) 전달. 반환값 = 해제 함수.
 * 비정상 종료 3초 재연결(가시 상태만) · 빈 심볼이면 no-op.
 */
export function subscribeYahooTicks(
  symbols: string[],
  onTick: (t: YahooTick) => void,
): () => void {
  const subs = symbols.filter(Boolean);
  if (!subs.length) return () => {};

  let ws: WebSocket | null = null;
  let closed = false;
  let retryTimer: ReturnType<typeof setTimeout> | null = null;
  const connect = () => {
    if (closed) return;
    try {
      ws = new WebSocket('wss://streamer.finance.yahoo.com/?version=2');
    } catch {
      scheduleRetry();
      return;
    }
    ws.onopen = () => { try { ws?.send(JSON.stringify({ subscribe: subs })); } catch { /* noop */ } };
    ws.onmessage = (ev) => {
      try {
        const t = decodePricing(JSON.parse(ev.data)?.message || '');
        if (t) onTick(t);
      } catch { /* 형식 밖 무시 */ }
    };
    ws.onclose = () => { if (!closed) scheduleRetry(); };
    ws.onerror = () => { try { ws?.close(); } catch { /* noop */ } };
  };
  const scheduleRetry = () => {
    if (closed || retryTimer) return;
    retryTimer = setTimeout(() => {
      retryTimer = null;
      if (document.visibilityState === 'visible') connect();
      else scheduleRetry();
    }, 3000);
  };
  connect();
  return () => {
    closed = true;
    if (retryTimer) clearTimeout(retryTimer);
    try { ws?.close(); } catch { /* noop */ }
  };
}
